var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.294291 1.69817C0.201076 1.60626 0.127058 1.49673 0.0765371 1.37596C0.0260161 1.25519 0 1.12559 0 0.994675C0 0.863763 0.0260161 0.734157 0.0765371 0.613387C0.127058 0.492617 0.201076 0.383092 0.294291 0.291175C0.483309 0.104608 0.738206 0 1.00379 0C1.26938 0 1.52427 0.104608 1.71329 0.291175L4.67829 3.23117C4.78049 3.33251 4.8616 3.45308 4.91696 3.58592C4.97231 3.71877 5.00081 3.86126 5.00081 4.00517C5.00081 4.14909 4.97231 4.29158 4.91696 4.42443C4.8616 4.55727 4.78049 4.67784 4.67829 4.77917L1.72329 7.70917C1.53423 7.89604 1.27912 8.00084 1.01329 8.00084C0.747463 8.00084 0.492353 7.89604 0.303291 7.70917C0.210077 7.61726 0.136058 7.50773 0.085537 7.38696C0.0350159 7.26619 0.00899982 7.13659 0.00899982 7.00567C0.00899982 6.87476 0.0350159 6.74516 0.085537 6.62439C0.136058 6.50362 0.210077 6.39409 0.303291 6.30217L2.62129 4.00517L0.294291 1.69817Z",
    fill: "#42526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleRight);
export default __webpack_public_path__ + "static/media/toggleRight.b51395f98f6f991314474a72648d861b.svg";
export { ForwardRef as ReactComponent };